import { ECommerceProps } from "@omni/types/components/props/eCommerce.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { OnAddToCartHandler } from "./actionHandlers/onAddToCart.handler";
import { OnSubmitHandler } from "./actionHandlers/onSubmit.handler";
import { ECommerceContextProvider } from "./context/eCommerce.context";

export type BaseProps = ECommerceProps & {
    handlers: {
        onSubmit: OnSubmitHandler;
        onAddToCart: OnAddToCartHandler;
    };
};

export const Base = ({
    children,
    product,
    infoLink,
    tooltips,
    cashbackPagePath,
    contextAwareXfPath,
    paintConfiguratorPath,
    handlers
}: RequireChildrenFor<BaseProps>) => {
    return (
        <ECommerceContextProvider
            product={product}
            infoLink={infoLink}
            tooltips={tooltips}
            contextAwareXfPath={contextAwareXfPath}
            paintConfiguratorPath={paintConfiguratorPath}
            cashbackPagePath={cashbackPagePath}
            handlers={handlers}
        >
            {children}
        </ECommerceContextProvider>
    );
};
